import request from '@/utils/request1';

import { huaxiaUrl, feedbackUrl } from './hostConfig';

const BASE_URL = '/api';

/** 任务中心用户视频信息
 * *** */
const getTaskStatusApi = (data) => request({
  url: BASE_URL + '/advertisement/userStatus',
  method: 'GET',
  data,
});

/** 任务中心用户信息
 * *** */
const getUserInfoApi = (data) => request({
  url: BASE_URL + '/taskCenter/getUserInfo',
  method: 'POST',
  data,
});

const getTaskInfoApi = (data) => request({
  url: BASE_URL + '/taskCenter/getTaskInfo',
  method: 'POST',
  data,
});

const getSignUpApi = (data) => request({ // 报名
  url: BASE_URL + '/taskCenter/signUp',
  method: 'POST',
  data,
});

const getReceiveRewardsApi = (data) => request({ // 去领取会员
  url: BASE_URL + '/taskCenter/receiveRewards',
  method: 'POST',
  data,
});

const getLooveeLinkApi = (data) => request({ // 获取抓娃娃链接
  url: BASE_URL + '/dollTribe/getLink',
  method: 'GET',
  data,
});

const huaxiaDataSubmitApi = (data) => request({ // 华夏银行用户数据
  url: huaxiaUrl + '/huaxia/api/pre/submit',
  method: 'POST',
  data,
});

const huaxiaMobileSubmitApi = (data) => request({ // 华夏银行用户数据1
  url: huaxiaUrl + '/huaxia/api/get/submit/link',
  method: 'GET',
  data,
});

const newLinkApi = (data) => request({ // 华夏银行用户数据
  url: BASE_URL + '/getLink',
  method: 'GET',
  data,
});

const contentDetailListApi = (data, header) => request({ // 发现页查看更多页面
  url: BASE_URL + '/findPage/tab/contentDetailList',
  method: 'GET',
  header,
  data,
});

const sendSmsApi = (data, header) => request({ // 支付验证码
  url: BASE_URL + '/sendSms',
  method: 'POST',
  header,
  data,
});

const payApi = (data, header) => request({ // 支付
  url: BASE_URL + '/common/pay',
  method: 'POST',
  header,
  data,
});

const generatorMailOrderApi = (data, header) => request({ // 生成发送邮件订单
  url: BASE_URL + '/order/generatorMailOrder',
  method: 'POST',
  header,
  data,
});

const generatorRecoverDataOrderApi = (data, header) => request({ // 生成恢复数据订支付单
  url: BASE_URL + '/order/generatorRecoverDataOrder',
  method: 'POST',
  header,
  data,
});

const queryUserAccountSmallChangeApi = (data, header) => request({ // 查询零钱
  url: BASE_URL + '/user/account/queryUserAccountSmallChange',
  method: 'POST',
  header,
  data,
});

const getThirdNorthUrlApi = (data, header) => request({ // 获取跳转第三方指北地址
  url: BASE_URL + '/blindBox/getZbUrl',
  method: 'GET',
  header,
  data,
});

export {
  getTaskStatusApi,
  getUserInfoApi,
  getTaskInfoApi,
  getSignUpApi,
  getReceiveRewardsApi,
  getLooveeLinkApi,
  huaxiaDataSubmitApi,
  newLinkApi,
  huaxiaMobileSubmitApi,
  contentDetailListApi,
  sendSmsApi,
  payApi,
  generatorMailOrderApi,
  generatorRecoverDataOrderApi,
  queryUserAccountSmallChangeApi,
  getThirdNorthUrlApi,
};
